module.exports = __webpack_public_path__ + "img/successavatar.cced1ca2.png";